
import { Box, MenuItem, TextField } from '@mui/material';
import { BoxFC, BoxFR } from 'components/BoxCustom';
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand';
import React, { useCallback, useState, useContext, useEffect, useMemo } from 'react';
import { GlobalStateContext } from 'contexts/GlobalStateContext';
import DateTimeSelect from 'components/DateTimeSelect';
import SearchButton from 'components/buttons/SearchButton';
import ClearButton from 'components/buttons/ClearButton';
import { initFilterData, clearFilterData } from './initData';
import { branchApiNm } from 'branch/constant/branchApiNm';
import { driverTripPaymentColumns } from './columns';
import { green, grey, red } from '@mui/material/colors';
import ComboBox from 'components/ComboBox';
import { alertError } from 'components/Alert';
import SelectMonthDialog from './SelectMonthDialog';
import { DesktopDatePicker } from '@mui/x-date-pickers-pro';
import { addIdForDataGrid } from 'utils';
import DailyJobDialogV3 from 'pages/Menu1/DailyJob/DailyJobDialogV3';
import dayjs from 'dayjs';
import AddDriverTripDialog from './AddDriverTripDialog';
import OtherDriverTripDialog from './OtherDriverTripDialog';
import CheckboxFormControl from 'components/CheckboxFormControl';
import { jobOrderColNm } from 'constants/jobOrderConstant';
// import { printJobOrder } from 'branch/functions/printJobOrder';

// let selectedId = null;
let lastFilter = null
let jobOrdId = null
let selectedPCTrnsIds = []
let selectedSalDte = null
let selectedPCItmId = null
let selectedRow = {}
let suggestDrvIds = []

export const driverTripWatchCols = [89, 90, 91]
// const watchFields = driverTripWatchCols.map(id => `E${id}`)

/**
 * DOC:: One job order one saldte for all pc_transaction if want to add another saldte use child job order
 */
const DriverTripPayment = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogAddDriverTripOpen, setDialogAddDriverTripOpen] = useState(false)
  const [dialogSelectMonth, setDialogSelectMonthOpen] = useState(false)
  const [dialogOtherDriverTripOpen, setDialogOtherDriverTripOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [selectionModel, setSelectionModel] = useState([])

  const textFieldProps = useCallback((name) => ({
    size: "small",
    sx: { width: 120 },
    value: filterData[name] ?? "",
    onChange: (e) => { setFilterData(o => ({ ...o, [name]: e.target.value || null })) }
  }), [filterData])

  const monthPickerProp = useMemo(() => ({
    disableMaskedInput: true,
    openTo: "month",
    views: ["year", "month"],
    label: "คิดเงินเดือน",
    inputFormat: "MMMM YYYY",
    value: filterData.SalDte,
    onChange: (newValue) => { setFilterData(o => ({ ...o, SalDte: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 160 }} />,

  }), [filterData.SalDte])

  const setAllData = useCallback((datas) => {
    setDataTable(addIdForDataGrid(datas, 'id'))
    setSelectionModel([])
  }, [])

  const getData = useCallback((filter) => {
    ax.post(branchApiNm.getDriverTripPaymentV2, filter).then(value => {
      if (value.data) {
        // setDataTable(addIdForDataGrid(value.data, 'PCTrnsId'))
        lastFilter = filter
        setAllData(value.data)
      }
    })
  }, [ax, setAllData])



  const handleCellClick = useCallback((params) => {
    // selectedId = params.id
    if (params.field === 'ShowDetail') {
      jobOrdId = params.row.JobOrdId
      setDialogOpen(true)
    } else if (params.field === "AddData") {
      selectedPCItmId = null
      selectedRow = params.row
      suggestDrvIds = [params.row.Sts1DrvId, params.row.Sts3DrvId, params.row.Sts5DrvId].filter(id => id)
      console.log("suggestDrvIds::", suggestDrvIds)
      setDialogAddDriverTripOpen(true)
    } else if (params.field === "JobSNm") {
      if (selectionModel.length > 0) {
        setSelectionModel([])
      } else {
        setSelectionModel([...dataTable.filter(r => r.JobId === params.row.JobId).map(r => r.id)])
      }
    } else if (params.field === "OthExp") {
      if (params.value) {
        selectedRow = params.row
        setDialogOtherDriverTripOpen(true)
      }
    } else if (params.field === 'SalDte') {
      selectedSalDte = params.value
      if (selectionModel.includes(params.id)) {
        console.log("dataTable::", dataTable)
        const filtered = dataTable.filter(r => selectionModel.includes(r.id))
        if (filtered.some(r => r.PayAmnt === null)) {
          alertError("มีบางข้อมูลยังไม่ลงค่าเที่ยว ไม่สามารถลงคิดเงินเดือนได้")
          return
        }
        selectedPCTrnsIds = filtered.map(r => r.PCTrnsId)
      }
      setDialogSelectMonthOpen(true)
    }
  }, [selectionModel, dataTable])

  const onFinish = useCallback((data) => {
    getData(lastFilter)
  }, [getData])


  const onSelectMonthDialogFinish = useCallback((data) => {
    const postData = {
      PCTrnsIds: selectedPCTrnsIds,
      SalDte: data,
      getArgs: lastFilter
    }
    ax.post(branchApiNm.insertDeleteSalaryPCTrnsaction, postData).then(value => {
      if (value.data) {
        setAllData(value.data)
      }
    })
  }, [ax, setAllData])

  const handleCellEditCommit = useCallback((params) => {
    console.log("params::", params)
    const foundRow = dataTable.find(r => r.id === params.id)

    const expId = foundRow.ExpId || 87

    if (params.value === null) {
      let pcTrnsIds = []
      if (selectionModel.includes(params.id)) {
        const filtered = dataTable.filter(r => selectionModel.includes(r.id))
        for (const row of filtered) {
          pcTrnsIds.push(row.PCTrnsId)
        }
      }
      else {
        const row = dataTable.find(r => r.id === params.id)
        pcTrnsIds = [row.PCTrnsId]
      }
      ax.post(branchApiNm.deleteDriverPayment, { PCTrnsIds: pcTrnsIds, getArgs: lastFilter }).then(value => {
        if (value.data) {
          setAllData(value.data)
        }
      })
    } else {
      if (selectionModel.includes(params.id)) {
        const updateArgsArr = []
        const insertArgsArr = []

        for (const id of selectionModel) {

          const row = dataTable.find(r => r.id === id)
          const foundExp = row.Exps.find(exp => exp.ExpId === expId)
          if (foundExp) {
            updateArgsArr.push({
              PCTrnsId: foundExp.PCTrnsId,
              PCItmId: foundExp.PCItmId,
              ExpId: expId,
              DrvId: params.row.DrvId,
              Dscp: "",
              PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
              Amnt: params.value,
            })
          } else {
            if (params.row.DrvId) {
              insertArgsArr.push({
                ExpId: expId,
                DrvId: params.row.DrvId,
                JobOrdId: row.JobOrdId,
                Amnt: params.value,
                SalDte: row.SalDte ? dayjs(row.SalDte).format("YYYY-MM-DD") : null
              })
            }
          }
        }
        const postData = {
          updateArgsArr,
          insertArgsArr,
          getArgs: lastFilter
        }
        ax.post(branchApiNm.insertUpdateDriverPayments, postData).then(value => {
          if (value.data) {
            setAllData(value.data)
          }
        })
      } else {
        const row = dataTable.find(r => r.id === params.id)
        if (row.PCItmId && row.PCTrnsId) {
          const postData = {
            PCTrnsId: row.PCTrnsId,
            PCItmId: row.PCItmId,
            ExpId: expId,
            DrvId: row.DrvId,
            Dscp: "",
            PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            Amnt: params.value,
            getArgs: lastFilter
          }
          ax.post(branchApiNm.updateDriverPaymentAmnt, postData, false).then(value => {
            if (value.data) {
              setAllData(value.data)
            }
          })
        } else {
          const postdata = {
            ExpId: expId,
            DrvId: row.DrvId,
            JobOrdId: row.JobOrdId,
            Amnt: params.value,
            SalDte: row.SalDte ? dayjs(row.SalDte).format("YYYY-MM-DD") : null,
            getArgs: lastFilter
          }
          ax.post(branchApiNm.insertDriverPayment, postdata, false).then(value => {
            if (value.data) {
              setAllData(value.data)
            }
          })
        }
      }
    }

  }, [dataTable, ax, selectionModel, setAllData])

  const onAddDriverTripDialogFinish = useCallback((data) => {
    if (data) {
      setAllData(data)
    } else {
      getData(lastFilter)
    }
  }, [setAllData, getData])

  const handleInsertDriverTripPaymentRow = useCallback((row) => {
    console.log("row::", row)

    let tripAmnt = 0;
    const nextRow = dataTable.find(r => r.No === row.No + 1)
    const prevRow = dataTable.find(r => r.No === row.No - 1)
    const filteredExps = msData.expensePOIs.filter(exp => 
      ([89, 91].includes(exp.ExpId) || (exp.ExpId === 90 && exp.JobId === row.JobId))
      && (!exp.ShpmTypId || exp.ShpmTypId === row.ShpmTypId)
      && (!exp.ContSize || exp.ContSize === row.ContSize)
      && (!exp.ContTyp || exp.ContTyp === row.ContTyp)
      && (!exp.TlrTypId || exp.TlrTypId === row.TlrTypId)
      && (!exp.POIId || exp.POIId === row.LocPOIId))
    console.log("filteredExps::", filteredExps)
    if (filteredExps.length === 0) {
      alertError("ไม่พบค่าเที่ยวที่ตรงกับข้อมูลใบงาน")
      return
    }
    // console.log("row.ContStsIds::", row.ContStsIds, row.ContStsIds.includes(3))
    const checkAndAddTripAmnt = (stsId, expId) => {
      if (row.ContStsIds.includes(stsId)) {
        const found = filteredExps.find(exp => exp.ExpId === expId)
        if (found) {
          let untPr = +found.UntPr
          if (nextRow && row.DrvId === nextRow.DrvId && row.ContSize === '20'
            && dayjs(row.StsTm).diff(dayjs(nextRow.StsTm), 'minutes') <= 30) {
            if (stsId === 1 && nextRow.ContStsIds.includes(stsId) && nextRow.TakePOIId === row.TakePOIId) {
              tripAmnt += untPr / 2
            } else if (stsId === 5 && nextRow.ContStsIds.includes(stsId) && nextRow.RtnPOIId === row.RtnPOIId) {
              tripAmnt += untPr / 2
            } else {
              tripAmnt += untPr
            }
          } else if (prevRow && row.DrvId === prevRow.DrvId && row.ContSize === '20'
            && dayjs(row.StsTm).diff(dayjs(prevRow.StsTm), 'minutes') <= 30) {
            if (stsId === 1 && prevRow.ContStsIds.includes(stsId) && prevRow.TakePOIId === row.TakePOIId) {
              tripAmnt += untPr / 2
            } else if (stsId === 5 && prevRow.ContStsIds.includes(stsId) && prevRow.RtnPOIId === row.RtnPOIId) {
              tripAmnt += untPr / 2
            } else {
              tripAmnt += untPr
            }
          } else {
            tripAmnt += untPr
          }
          return true
        } else {
          alertError(`ไม่พบ ${msData.expObj[expId]?.ExpNm} ที่ตรงกับข้อมูลใบงาน`)
          return false
        }
      }
      return true
    }
    const checkResult = checkAndAddTripAmnt(1, 89)
    && checkAndAddTripAmnt(3, 90)
    && checkAndAddTripAmnt(5, 91)

    if(!checkResult) return
    
    if (tripAmnt === 0) {
      alertError("ไม่พบค่าเที่ยวที่ตรงกับข้อมูลใบงาน")
      return
    }
    // }
    console.log("tripAmnt::", tripAmnt)


    setDataTable(o => {
      const newData = [...o]
      const index = newData.findIndex(r => r.id === row.id)
      if (index !== -1) {
        newData[index].PayAmnt = tripAmnt
      }
      return newData
    })
    const postData = {
      ExpId: 87,
      DrvId: row.DrvId,
      JobOrdId: row.JobOrdId,
      Amnt: tripAmnt,
      SalDte: row.SalDte ? dayjs(row.SalDte).format("YYYY-MM-DD") : null,
      // getArgs: lastFilter
    }
    ax.post(branchApiNm.insertDriverPayment, postData, false).then(value => {
      setDataTable(o => {
        let payAmnt = null
        if (value.data) {
          payAmnt = tripAmnt
        }
        const newData = [...o]
        const index = newData.findIndex(r => r.id === row.id)
        if (index !== -1) {
          newData[index].PayAmnt = payAmnt
          newData[index].PCTrnsId = value.data
        }
        return newData
      })

    })
  }, [ax, dataTable, msData.expensePOIs, msData.expObj])

  const driverTripPaymentColumnsMemo = useMemo(() => {
    const cols = driverTripPaymentColumns(handleInsertDriverTripPaymentRow)
    for (const col of cols) {
      if (["E89", "E90", "E91"].includes(col.field)) {
        col.headerName = msData.expObj[+col.field.substring(1)]?.ExpNm
      }
    }
    return cols
  }, [msData.expObj, handleInsertDriverTripPaymentRow])

  const handleKeyUp = useCallback((e) => {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      getData(filterData)
    }
  }, [getData, filterData])

  // const handlePrintBlankJobOrder = useCallback(() => {
  //   console.log("in HandlePrintBlankJobOrder")
  //   const printObj = { 
  //     jobOrderData : {}, 
  //     shipmentData: {}, 
  //     jobOrdIds: [], 
  //     isPrintDateTime: false, 
  //     fName: "" }
  //   printJobOrder({printDataArr: [printObj], msData})  
  // }, [msData])

  useEffect(() => {
    getData({ ...initFilterData })
  }, [getData])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        {/* <Button variant="contained"  onClick={handlePrintBlankJobOrder}><PrintRounded sx={{mr:1}} />พิมพ์ใบงานเปล่า</Button> */}
        <Box flex={1} />
        <TextField {...textFieldProps('PaySts')} sx={{ width: 150 }} label="สถานะลงค่าเที่ยว" select
          onChange={e => setFilterData(o => ({ ...o, PaySts: e.target.value }))} >
          <MenuItem value={null}>ไม่ระบุ</MenuItem>
          <MenuItem value={1}>ลงค่าเที่ยวแล้ว</MenuItem>
          <MenuItem value={0}>ยังไม่ลงค่าเที่ยว</MenuItem>
        </TextField>
        <TextField {...textFieldProps('JobOrdId')} label="เลขที่ใบงาน" onKeyUp={handleKeyUp} />
        <TextField {...textFieldProps('ContNo')} label="หมายเลขตู้" onKeyUp={handleKeyUp} />
        <ComboBox sx={{ width: 150 }} options={msData.jobCombo} label="งาน"
          selectedId={filterData.JobId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, JobId: id }))}
        />
        <ComboBox sx={{ width: 150 }} options={msData.driverOnlyCombo} label={"พนักงานขับรถ"}
          selectedId={filterData.DrvId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, DrvId: id }))}
        />
        <DateTimeSelect sx={{ width: 180 }} label={jobOrderColNm.AptTm} start={filterData.AptTmSt} end={filterData.AptTmEn}
          setSelectDate={(st, en) => { setFilterData(o => ({ ...o, AptTmSt: st, AptTmEn: en })) }}
          getData={() => { getData(filterData) }}
        />
        <DateTimeSelect sx={{ width: 180 }} label='วันที่วิ่งงาน' start={filterData.StsTmSt} end={filterData.StsTmEn}
          setSelectDate={(st, en) => { setFilterData(o => ({ ...o, StsTmSt: st, StsTmEn: en })) }}
          getData={() => { getData(filterData) }}
        />

        <Box sx={{ position: "relative" }}>
          <DesktopDatePicker {...monthPickerProp} />
          <CheckboxFormControl sx={{ position: "absolute", bottom: -24, left: 0 }} label="ระบุุคิดเงินเดือน"
            checked={filterData.IsFilterSalDte === 1}
            onChange={(e) => setFilterData(o => ({ ...o, IsFilterSalDte: e.target.checked ? 1 : 0 }))} />
        </Box>

        <SearchButton onClick={(() => getData(filterData))} />
        <ClearButton onClick={(() => setFilterData({ ...clearFilterData }))} />
      </BoxFR>
      <Box height='100%' sx={{
        mt: 1,
        "& .bg-red": { bgcolor: red[100] },
        "& .bg-green": { bgcolor: green[100] },
        "& .disabled": { bgcolor: grey[200] }
      }}>
        <DataGridCellExpand
          hideFooter
          checkboxSelection
          selectionModel={selectionModel}
          onSelectionModelChange={(ids) => {
            setSelectionModel(ids);
          }}
          rows={dataTable}
          columns={driverTripPaymentColumnsMemo}
          onCellEditCommit={handleCellEditCommit}
          onCellClick={handleCellClick}
        // isCellEditable={isCellEditable}
        // experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
      <DailyJobDialogV3
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        selectedId={jobOrdId}
        onFinish={onFinish} />
      <SelectMonthDialog
        oldData={selectedSalDte}
        dialogOpen={dialogSelectMonth}
        setDialogOpen={setDialogSelectMonthOpen}
        onFinish={onSelectMonthDialogFinish} />
      <AddDriverTripDialog
        dialogOpen={dialogAddDriverTripOpen}
        setDialogOpen={setDialogAddDriverTripOpen}
        pcItmId={selectedPCItmId}
        dataRow={selectedRow}
        suggestDrvIds={suggestDrvIds}
        onFinish={onAddDriverTripDialogFinish}
        lastFilter={lastFilter}
      />
      <OtherDriverTripDialog
        jobOrdId={selectedRow?.JobOrdId}
        dialogOpen={dialogOtherDriverTripOpen}
        setDialogOpen={setDialogOtherDriverTripOpen}
        lastFilter={lastFilter}
        suggestDrvIds={suggestDrvIds}
        onFinish={onAddDriverTripDialogFinish}
        joData={selectedRow}

      />
    </BoxFC>
  );
}

export default DriverTripPayment